import {createSlice} from "@reduxjs/toolkit";


const initialState = {
    listLoading: false,
    actionsLoading: false,
    entities: [],
    totalCount: 0,
    lastError: null
  };

  export const callTypes = {
    list: "list",
    action: "action"
  };
  

const regionSlice = createSlice({
    name: 'regionSlice',
    initialState:initialState,
    reducers: {
        catchError: (state, action) => {
          state.lastError = `${action.type}: ${action.payload.error}`;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = false;
          } else {
            state.actionsLoading = false;
          }
        },
        startCall: (state, action) => {
          state.lastError = null;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = true;
          } else {
            state.actionsLoading = true;
          }
        },
        regionsLoaded: (state, action) => {
          const {entities,totalCount} = action.payload;
          state.listLoading = false;
          state.lastError = null;
          state.entities = entities;
          state.totalCount = totalCount;
        }
      }
});

export const {actions} = regionSlice;
export const {reducer} = regionSlice;